<template>
  <!-- Pestaña 10 · Taquizas — Fase 5 DIFERIDA. Oculta por el flag events.taquizas. -->
  <exec-placeholder
    title="Taquizas — Fase 5 (diferida)"
    message="El módulo de taquizas (eventos) no está implementado todavía. Se habilitará al activar el flag events.taquizas en una fase posterior."
  />
</template>

<script>
import ExecPlaceholder from './ExecPlaceholder.vue';
// Pestaña 10 · Taquizas (doc 04 §3, reporte 10). Diferida a Fase 5.
export default { name: 'ExecEvents', components: { ExecPlaceholder }, props: { filters: { type: Object, default: () => ({}) } } };
</script>
